import styled from 'styled-components';
import { layout } from 'src/components/base';

export const SelectedFiltersWrapper = styled.div`
  width: 100%;
  padding: 0 10px;
  margin-bottom: ${layout.measurements.spacing050};

  & > button {
    margin-bottom: ${layout.measurements.spacing025};
  }
`;
